import React from 'react';
import { Search } from 'lucide-react';
import './SearchBar.css';

export function SearchBar({ value, onChange, onKeyPress, placeholder }) {
  return (
    <div className="search-bar-container">
      <div className="search-icon-wrapper">
        <Search size={20} className="search-icon" />
      </div>
      <input
        type="text"
        className="search-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
      />
    </div>
  );
}
